export default "__VITE_ASSET__s9Z53Xig__"